import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import TinyDatePicker from 'tiny-date-picker';
import {isEmpty} from 'lodash/fp';
import * as actions from '../store/actions/index';
import * as constants from '../store/constants';
import * as validations from '../store/validations';
import * as utility from '../store/utility';
import * as utilities from '../store/utility';
import '../assets/styles/css/tiny-date-picker.css';
import HP from '../templates/consents/hp';
import OL from '../templates/consents/ol';
import Button from './ui/Button';
import ButtonWrap from './ui/forms/ButtonWrap';
import BackButton from './ui/BackButton';
import NRICLogin from './KYCStages/NRICLogin';
import ApplicationDetails from './KYCStages/ApplicationDetails';
import ApplicationChoice from './KYCStages/ApplicationChoice';
import ApplicantDetails from './KYCStages/ApplicantDetails';
import ContactDetails from './KYCStages/ContactDetails';
import OccupationDetails from './KYCStages/OccupationDetails';
import OTP from './KYCStages/OTP';
import ApplicationMessages from './KYCStages/ApplicationMessages';
import SessionIdleTimer from './SessionIdleTimer/SessionIdleTimer';
import TitleWrap from './ui/TitleWrap';
import BodyWrap from './ui/BodyWrap';
import {validateNIRC} from './utilities/validation';

class KYC extends Component {

    constructor(props) {
        super(props);
        this.state = {
            stageTitle: 'Finance Application',

            nric1: '',
            nric2: '',
            nric3: '',
            nric4: '',

            showError: false,

            stage2_referenceNo: '',
            stage2_price: '',
            stage2_make: '',
            stage2_model: '',
            stage2_loanAmount: '',
            stage2_loanPercent: '',
            stage2_tenure: '',
            stage2_interestRate: '',

            stage3_consent: false,

            myInfoMode: false,

            stage4_name_error: '',
            stage4_nric_error: '',
            stage4_dob_error: '',
            stage4_gender_error: '',
            stage4_race_error: '',
            stage4_maritalStatus_error: '',
            stage4_nationality_error: '',
            stage4_residentialStatus_error: '',
            stage4_drivingLicense_error: '',
            stage4_drivingLicenseClass_error: '',
            stage4_licenseIssueDate_error: '',
            stage4_licenseValidity_error: '',
            stage4_licenseExpiryDate_error: '',
            stage4_file_error: '',

            stage5_mobile_error: '',
            stage5_home_error: '',
            stage5_email_error: '',
            stage5_block_error: '',
            stage5_unit_error: '',
            stage5_street_error: '',
            stage5_building_error: '',
            stage5_country_error: '',
            stage5_postal_error: '',

            stage5_mobile_bms: '',
            stage5_email_bms: '',
  
            stage6_employer_error: '',
            stage6_occupation_error: '',
            stage6_assessableIncome_error: '',
            stage6_yearOfNotice_error: '',
            stage6_file_error: '',
            stage4_name: '',
            stage4_nric: '',
            stage4_dob: '',
            stage4_gender: '',
            stage4_genderList: [
            ],
            stage4_race: '',
            stage4_raceList: [
            ],
            stage4_maritalStatus: this.props.applicantDetails.maritalStatus.value,
            stage4_maritalStatusList: [
            ],
            stage4_nationality: 'SG',
            stage4_nationalityList: [
            ],
            stage4_residentialStatus: '',
            stage4_residentialStatusList: [
            ],
            stage4_drivingLicense: 'Qualified',
            stage4_drivingLicenseClass: '',
            stage4_licenseIssueDate: '',
            stage4_licenseValidity: '',
            stage4_licenseExpiryDate: '',

            stage4_drivingLicenseClass_pdl: '',
            stage4_licenseValidity_pdl: '',
            stage4_licenseExpiryDate_pdl: '',

            stage4_drivingLicenseObj: constants.applicantDetails.drivingLicense,
            stage4_files_nric: [],
            stage4_files: [],
            stage4_UploadedFiles: [],
            stage5_mobile: '',
            stage5_home: '',
            stage5_email: '',
            stage5_block: '',
            stage5_unit: '',
            stage5_street: '',
            stage5_building: '',
            stage5_country: 'SG',
            stage5_countryList: [
            ],
            stage5_postal: '',
            stage5_sameAddress: false,
            stage5_mailingBlock: '',
            stage5_mailingUnit: '',
            stage5_mailingStreet: '',
            stage5_mailingBuilding: '',
            stage5_mailingCountry: '',
            stage5_mailingPostal: '',

            stage6_employer: '',
            stage6_occupation: '',
            stage6_assessableIncome: '',
            stage6_yearOfNotice: '',
            stage6_yearOfNoticeList: [],
            stage6_contribution: [],

            stage6_files: [],
            stage6_files_others: [],

            stage7_consent: false,
            stage7_market: false,
            stage7_amount: '0',

            otp1: '',
            otp2: '',
            otp3: '',
            otp4: '',
            otp5: '',
            otp6: '',
            stage7_emailConsent: false,
            stage7_smsConsent: false,
            stage7_callConsent: false,
            stage7_marketAgree: false,
            stage7_marketNotAgree: false,
            isDatePickerInitialized: false,
            myInfoSixMonthData: false
        }

    }
    
    componentDidUpdate(prevProps, previousState) {
        if (this.props.state.main.stage === 1 &&
            this.props.state.main.stage !== this.props.state.checkNRICSessionReducer.state &&
            !this.props.state.getApplicationReducer.fetching) {
            this.props.onGetApplicationDetails(this.props.sessionId);
        }
        if (this.props.state.main.stage === 7 && prevProps.state.main.stage !== this.props.state.main.stage) {
            window.scrollTo(0, 0);
        }
        if (this.props.state.main.stage === 4 &&
            ((this.props.state.main.stage !== prevProps.state.main.stage) ||
                (this.props.errorMyInfoFailed !== ''))
            && !this.props.myInfo) {
            this.onInitTDP('#tdp_dob', 'stage4_dob', new Date());
            if (this.state.stage4_drivingLicense.toUpperCase() === 'QUALIFIED') {
                this.onInitTDP('.tdp_issueDate', 'stage4_licenseIssueDate', new Date());
                this.onInitTDP('.tdp_expiryDate', 'stage4_licenseExpiryDate', '')
            }
            if (this.state.stage4_drivingLicense.toUpperCase() === 'PROVISIONAL') {
                this.onInitTDP('.tdp_expiryDate', 'stage4_licenseExpiryDate_pdl', '')
            }
        }

        if ((prevProps.applicantDetails !== this.props.applicantDetails
            && this.props.applicantDetails !== null
            && this.props.applicantDetails !== {}
            && this.props.myInfo) || previousState.myInfoSixMonthData !== this.state.myInfoSixMonthData) {
            if (!this.state.isDatePickerInitialized && this.props.state.main.stage === 4) {
                this.onInitTDP('#tdp_dob', 'stage4_dob', new Date());
                if (this.props.applicantDetails.drivingLicense.qdl) {
                    this.onInitTDP('.tdp_issueDate', 'stage4_licenseIssueDate', new Date());
                    this.onInitTDP('.tdp_expiryDate', 'stage4_licenseExpiryDate', '')
                } else if (this.props.applicantDetails.drivingLicense.pdl) {
                    this.onInitTDP('.tdp_expiryDate', 'stage4_licenseExpiryDate', '')
                }
            }

            const {applicantDetails} = this.props;
            const drivLicense = applicantDetails.drivingLicense;
            if (drivLicense.qdl != null) {
                if (drivLicense.qdl.classes.length > 0) {
                    drivLicense.qdl.classes.forEach(element => {
                        element.issueDate = !element.issueDate ? '' : utilities.formatDate(new Date(Date.parse(element.issueDate)));
                    });
                }
                drivLicense.qdl.expirydate = !drivLicense.qdl.expirydate ? '' : utilities.formatDate(new Date(Date.parse(drivLicense.qdl.expirydate)));
            }
            if (drivLicense.pdl != null) {
                drivLicense.pdl.expirydate = !drivLicense.pdl.expirydate ? '' : utilities.formatDate(new Date(Date.parse(drivLicense.pdl.expirydate)));
            }
            this.setState({
                stage4_name: applicantDetails.name.value,
                stage4_nric: applicantDetails.identityNo.value,
                stage4_dob: applicantDetails.dob.value === null ? '' : utilities.formatDate(new Date(Date.parse(applicantDetails.dob.value))),
                stage4_gender: applicantDetails.gender.value,
                stage4_race: applicantDetails.race.value,
                stage4_maritalStatus: applicantDetails.maritalStatus.value,
                stage4_nationality: applicantDetails.nationality.value,
                stage4_residentialStatus: applicantDetails.residentialStatus.value,

                stage4_drivingLicense: applicantDetails.drivingLicense.status,
                stage4_drivingLicenseClass: applicantDetails.drivingLicense.licenseClass === null ? '' : applicantDetails.drivingLicense.licenseClass,
                stage4_licenseIssueDate: applicantDetails.drivingLicense.issueDate === null ? '' : utilities.formatDate(new Date(Date.parse(applicantDetails.drivingLicense.issueDate))),
                stage4_licenseValidity: applicantDetails.drivingLicense.validity === null ? '' : applicantDetails.drivingLicense.validity,
                stage4_licenseExpiryDate: applicantDetails.drivingLicense.expiryDate === null ? '' : utilities.formatDate(new Date(Date.parse(applicantDetails.drivingLicense.expiryDate))),

                stage4_drivingLicenseClass_pdl: applicantDetails.drivingLicense.provisionalClass === null ? '' : applicantDetails.drivingLicense.provisionalClass,
                stage4_licenseValidity_pdl: applicantDetails.drivingLicense.provisionalValidity === null ? '' : applicantDetails.drivingLicense.provisionalValidity,
                stage4_licenseExpiryDate_pdl: applicantDetails.drivingLicense.provisionalExpiryDate === null ? '' : utilities.formatDate(new Date(Date.parse(applicantDetails.drivingLicense.provisionalExpiryDate))),

                stage4_drivingLicenseObj: applicantDetails.drivingLicense,
                stage5_mobile: applicantDetails.contactDetails.mobileNo.value,
                stage5_email: applicantDetails.contactDetails.emailAddress.value,

                stage5_block: applicantDetails.residentialAddress.block,
                stage5_street: applicantDetails.residentialAddress.street,
                stage5_building: applicantDetails.residentialAddress.building,
                stage5_unit: applicantDetails.residentialAddress.unit,
                stage5_country: applicantDetails.residentialAddress.country,
                stage5_postal: applicantDetails.residentialAddress.postalCode,

                stage6_employer: applicantDetails.employment.employer.value,
                stage6_occupation: applicantDetails.employment.occupation.value,
                stage6_assessableIncome: applicantDetails.employment.assessibleIncome.value,
                stage6_yearOfNotice: applicantDetails.employment.assessmentYear.value,

                stage6_contribution: applicantDetails.employment.cpfContributions !== null ? (applicantDetails.employment.cpfContributions.length > 0 ? applicantDetails.employment.cpfContributions : []) : []
            });
        }
        if (prevProps.appForm !== this.props.appForm ||
            (prevProps.applicantDetails !== this.props.applicantDetails &&
                this.props.myInfo)) {
            this.setState({
                stage4_name: this.props.myInfo ? this.props.applicantDetails.name.value : this.props.appForm.name,
                stage4_nric: this.props.myInfo ? this.props.applicantDetails.identityNo.value : this.props.appForm.identityNo,
                stage5_mobile: this.props.myInfo ? this.props.applicantDetails.contactDetails.mobileNo.value : this.props.appForm.mobileNo,
                stage5_email: this.props.myInfo ? this.props.applicantDetails.contactDetails.emailAddress.value : this.props.appForm.emailAddress,
                stage5_email_bms: this.props.appForm ? this.props.appForm.emailAddress : "",
                stage5_mobile_bms: this.props.appForm ? this.props.appForm.mobileNo : "",
            });
        }

    }


    async componentDidMount() {
        // Calculate Years for Date of Notice
        const date = new Date().getFullYear();
            const min = date;
            const max = date + 10;

        const yearList = [];

        for (let i = min; i <= max; i++) {
            const year = i.toString();
            yearList.push(year);
        }

        this.setState({
            stage6_yearOfNoticeList: yearList
        });
        // Brand specific data placeholders 
        if (this.props.appForm) {
            this.setState({
                stage2_referenceNo: this.props.appForm.rcoNo,
                stage2_price: 252000,
                stage2_make: 'Toyota',
                stage2_model: 'GR Supra 3.0',
                stage2_loanAmount: 151200,
                stage2_loanPercent: 40,
                stage2_tenure: '84 months',
                stage2_interestRate: '2.48%'
            })
        }

    }

    onInitTDP = (id, name, max) => {
        const this2 = this;
        TinyDatePicker(id, {
            mode: 'dp-below',
            max,
            format(date) {
                const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
                const day = (`0${  date.getDate()}`).slice(-2);
                const month = monthNames[date.getMonth()];// .toLocaleString('default', { month: 'short' });
                const year = date.getFullYear();
                const display = `${day  } ${  month  } ${  year}`
                this2.setState({
                    [name]: display
                })
                return display;
            },
            parse(str) {
                const date = new Date(str);
                return isNaN(date) ? new Date() : date;
            },

        }).on({
            select: (_, dp) => {
                if (!dp.state.selectedDate) {
                    this2.setState({
                        [name]: ''
                    });
                }

            },
        });

    }

    verifyFiles = (dataRaw, name) => {
        let msg = '';
        if (dataRaw != null && dataRaw.length > 0) {
            let filecount = dataRaw.length + this.state.stage4_files_nric.length;
            if (name === 'stage6_fileupload') {
                filecount = dataRaw.length + this.state.stage6_files.length;
            }
            if (filecount > 5) {
                msg = 'Only 5 files are allowed';
            }
            if (msg === '') {
                for (let i = 0; i < dataRaw.length; i++) {
                    const file = dataRaw[i];
                    const fileType = file.type;
                    const re = /(\/jpg|\/jpeg|\/bmp|\/tif|\/pdf|\/gif|\/png)$/i;
                    const filesize = Math.round((file.size / 1024));
                    if (filesize >= 5120) {
                        msg = 'File too Big, max. 5mb allowed';
                        break;
                    }
                    else if (!re.exec(fileType)) {
                        msg = 'File extension not supported'
                        break;
                    }
                }
            }
        }
        return msg
    }

    onFileUpload = (e) => {
        const dataRaw = e.target.files;
        const data = [...dataRaw];
        const {name} = e.target;
        const msg = this.verifyFiles(dataRaw, name);
        if (msg !== '') {
            if (name === 'stage4_files_nric') {
                this.setState(() => (
                    {
                        stage4_file_error: msg
                    }
                ))
            } else if (name === 'stage6_fileupload') {
                this.setState(() => (
                    {
                        stage6_file_error: msg
                    }
                ))
            }
        }
        else if (name === 'stage4_files') {
            this.setState(state =>(
                {
                    stage4_files: [...state.stage4_files, ...data],
                }
            ))
        }
        else if (name === 'stage4_files_nric') {
            this.setState(state => (
                {
                    stage4_files_nric: [...state.stage4_files_nric, ...data],
                    stage4_file_error: ''
                }
            ))

        } else if (name === 'stage6_fileupload') {
            this.setState(state => (
                {
                    stage6_files: [...state.stage6_files, ...data],
                    stage6_file_error: ''
                }
            ))
        } else if (name === 'stage6_fileupload_others') {
            this.setState(state => (
                {
                    stage6_files_others: [...state.stage6_files_others, ...data],
                }
            ))
        }
    }

    onFileRemove = (name, i) => {
        if (name === 'stage4_fileClose') {
            this.setState({
                stage4_files: this.state.stage4_files.filter((files) => files !== i)
            });
        } else if (name === 'stage4_file_nric_Close') {
            this.setState({
                stage4_files_nric: this.state.stage4_files_nric.filter((files) => files !== i)
            });
        } else if (name === 'stage6_fileClose') {
            this.setState({
                stage6_files: this.state.stage6_files.filter((files) => files !== i)
            });
        } else if (name === 'stage6_fileClose_others') {
            this.setState({
                stage6_files_others: this.state.stage6_files_others.filter((files) => files !== i)
            });
        }

    }

    onChangeStage = (stage) => {
        this.props.onChangeStage(stage);
    }

    dropDownValueSubString = (value) => {
        if (value.length > 15) {
            let text = value.slice(0, 15);
            text += "...";
            return text;
        } 
            return value;
        
    }

    validateApplicationForm = () => {
        const {applicantDetails} = this.props;
        if (applicantDetails) {
            if (applicantDetails.source.toUpperCase() === constants.MYINFO.toUpperCase()
                && applicantDetails.myInfoDate != null) {
                const sixMonthsAgo = new Date();
                sixMonthsAgo.setMonth(sixMonthsAgo.getMonth() - 6);
                const isSixMonthsNotValid = Date.parse(sixMonthsAgo) > Date.parse(applicantDetails.myInfoDate);

                if (isSixMonthsNotValid) {
                    this.onChangeStage(3);
                } else {

                    if (this.props.state.main.createCustomerFlow) {
                        const applicantDetails = this.mapStateToApplicantDetails();
                        this.props.onSubmitApplication(this.props.appForm, applicantDetails, this.state.stage4_files, this.state.stage6_files);
                    } else {
                        this.onChangeStage(7);
                        this.setState({ myInfoSixMonthData: true });
                    }
                    this.onChangeStage(7);
                    this.setState({ myInfoSixMonthData: true });

                }
                this.props.onUpdateSource(!isSixMonthsNotValid);
            } else {
                this.onChangeStage(3);
            }
        } else {
            this.onChangeStage(3);
        }
    }

    onCheckNRIC = () => {
        // check NRIC
        const nricNo = this.state.nric1 + this.state.nric2 + this.state.nric3 + this.state.nric4
        this.props.onCheckNRICSession(nricNo, this.props.sessionId);
        this.setState({
            showError: true
        });
    }

    onSetTitle = (stageTitle) => {
        this.setState({
            stageTitle
        })
    }

    onApply = (myInfoMode) => {
        this.setState({
            myInfoMode,
            stageTitle: '1. Applicant Details'
        }, () => {
            this.props.onUpdateSource(myInfoMode);
            myInfoMode ? this.props.onGetMyInfoData(this.props.sessionId, this.state.stage3_consent) : this.onChangeStage(4);
        })
    }

    validateApplicantDetails = () => {
        const applicantDetails = this.props.myInfo ? this.props.applicantDetails : constants.applicantDetails;

        let stage4_drivingLicense_error = '';
        let stage4_drivingLicenseClass_error = '';
        let stage4_licenseIssueDate_error = '';
        let stage4_licenseValidity_error = '';
        let stage4_licenseExpiryDate_error = '';
        let stage4_file_error = '';

        let stage4_drivingLicenseClass_pdl_error = '';
        let stage4_licenseValidity_pdl_error = '';
        let stage4_licenseExpiryDate_pdl_error = '';
        let stage6_file_error = '';

        const stage4_name_error = applicantDetails.name.source !== '1' ?
            validations.validateRequiredLettersOnly(this.state.stage4_name.trim()) : '';

        const isNIRCValid = validateNIRC(this.state.stage4_nric.trim(), this.state.stage4_dob.trim());
        const stage4_nric_error = applicantDetails.identityNo.source !== '1' ? (isNIRCValid ? '' : 'Invalid NRIC/FIN') : '';

        const stage4_dob_error = applicantDetails.dob.source !== '1' ?
            validations.validateDOB(this.state.stage4_dob.trim()) : '';

        const stage4_gender_error = applicantDetails.gender.source !== '1' ?
            validations.validateRequired(this.state.stage4_gender.trim()) : '';

        const stage4_race_error = applicantDetails.race.source !== '1' ?
            validations.validateRequired(this.state.stage4_race.trim()) : '';

        const stage4_maritalStatus_error = validations.validateRequired(this.state.stage4_maritalStatus.trim());

        const stage4_nationality_error = applicantDetails.nationality.source !== '1' ?
            validations.validateRequired(this.state.stage4_nationality.trim()) : '';

        const stage4_residentialStatus_error = applicantDetails.residentialStatus.source !== '1' ?
            validations.validateRequired(this.state.stage4_residentialStatus.trim()) : '';

        if (!this.props.myInfo) {
            stage4_file_error = validations.validateRequiredFiles(this.state.stage4_files_nric);

            stage6_file_error = validations.validateRequiredFiles(this.state.stage6_files);
        }
        if (applicantDetails.drivingLicense.source !== '1') {
            if (!this.props.myInfo) {
                stage4_drivingLicense_error = validations.validateRequired(this.state.stage4_drivingLicense.trim());
            }
            if (this.state.stage4_drivingLicense.toUpperCase() === 'PROVISIONAL') {
                stage4_drivingLicenseClass_pdl_error = validations.validateRequired(this.state.stage4_drivingLicenseClass_pdl.trim());
                stage4_licenseValidity_pdl_error = validations.validateRequired(this.state.stage4_licenseValidity_pdl.trim());
                if (this.state.stage4_licenseExpiryDate_pdl) {
                    stage4_licenseExpiryDate_pdl_error = validations.validateDrivingLicenseandExpiryDate(this.state.stage4_licenseExpiryDate_pdl.trim());
                }

                stage4_licenseIssueDate_error = "";
                stage4_licenseExpiryDate_error = "";
            } else if (this.state.stage4_drivingLicense.toUpperCase() === 'QUALIFIED') {
                stage4_drivingLicenseClass_error = validations.validateRequired(this.state.stage4_drivingLicenseClass.trim());
                stage4_licenseValidity_error = validations.validateRequired(this.state.stage4_licenseValidity.trim());
                if (this.state.stage4_licenseIssueDate) {
                    stage4_licenseIssueDate_error = validations.validateDrivingLicenseandExpiryDate(this.state.stage4_licenseIssueDate.trim());
                }
                if (this.state.stage4_licenseExpiryDate) {
                    stage4_licenseExpiryDate_error = validations.validateDrivingLicenseandExpiryDate(this.state.stage4_licenseExpiryDate.trim());
                }

                stage4_licenseExpiryDate_pdl_error = "";
            }
        }

        this.setState(
            {
                stage4_name_error,
                stage4_nric_error,
                stage4_gender_error,
                stage4_race_error,
                stage4_dob_error,
                stage4_maritalStatus_error,
                stage4_nationality_error,
                stage4_residentialStatus_error,
                stage4_drivingLicense_error,
                stage4_drivingLicenseClass_error,
                stage4_licenseIssueDate_error,
                stage4_licenseValidity_error,
                stage4_licenseExpiryDate_error,
                stage4_file_error,
                stage4_drivingLicenseClass_pdl_error,
                stage4_licenseValidity_pdl_error,
                stage4_licenseExpiryDate_pdl_error,
                stage6_file_error
            });
        if (
            stage4_name_error || stage4_nric_error || stage4_gender_error
            || stage4_race_error || stage4_maritalStatus_error || stage4_nationality_error
            || stage4_residentialStatus_error || stage4_drivingLicense_error
            || stage4_drivingLicenseClass_error || stage4_licenseIssueDate_error
            || stage4_licenseValidity_error || stage4_licenseExpiryDate_error
            || stage4_file_error || stage4_drivingLicenseClass_pdl_error
            || stage4_licenseValidity_pdl_error || stage4_licenseExpiryDate_pdl_error
            || stage4_dob_error
            ||stage6_file_error) {
            return false;
        }
        return true;
    }



    onVerifyApplicant = () => {
        const isValid = this.validateApplicantDetails();
        if (isValid) {
            this.setState({
                stageTitle: '2. Contact Details',
                isDatePickerInitialized: true
            }, () => {
                this.onChangeStage(5);
            })
        }

    }

    validateContactDetails = () => {
        let stage5_block_error = '';
        let stage5_unit_error = '';
        let stage5_street_error = '';
        let stage5_building_error = '';
        let stage5_country_error = '';
        let stage5_postal_error = '';
        const applicantDetails = this.props.myInfo ? this.props.applicantDetails : constants.applicantDetails;
        const mobileNoRegex = utility.getValidationValueByKey(this.props.validation, 'MobileNo');

        const stage5_mobile_error = applicantDetails.contactDetails.mobileNo.source !== '1' ?
            validations.validateWithRegex(this.state.stage5_mobile.trim(), mobileNoRegex, 'Invalid Mobile Number') : '';

        const stage5_email_error = applicantDetails.contactDetails.emailAddress.source !== '1' ?
            validations.validateEmail(this.state.stage5_email.trim()) : '';


        if (applicantDetails.residentialAddress.source !== '1') {
            stage5_block_error = validations.validateRequired(this.state.stage5_block.trim());
            stage5_unit_error = validations.validateRequired(this.state.stage5_unit.trim());
            stage5_street_error = validations.validateRequired(this.state.stage5_street.trim());
            stage5_building_error = validations.validateRequired(this.state.stage5_building.trim());
            stage5_country_error = validations.validateRequired(this.state.stage5_country.trim());
            stage5_postal_error = validations.ValidatePostalNumbers(this.state.stage5_postal.trim());
        }

        this.setState(
            {
                stage5_mobile_error,
                stage5_email_error,
                stage5_block_error,
                stage5_unit_error,
                stage5_street_error,
                stage5_building_error,
                stage5_country_error,
                stage5_postal_error
            })

        if (
            stage5_mobile_error || stage5_email_error || stage5_block_error
            || stage5_unit_error || stage5_street_error || stage5_building_error
            || stage5_country_error || stage5_postal_error) {

            return false;
        }


        return true;
    }

    onVerifyContact = () => {
        const isValid = this.validateContactDetails();
        if (isValid) {
            this.setState({
                stageTitle: '3. Occupation Details'
            }, () => {
                this.onChangeStage(6);
            })
        }

    }

    onBackApplicant = () => {
        this.setState({
            stageTitle: '1. Applicant Details'
        }, () => {
            this.onChangeStage(4)
        })
    }

    validateOccupation = () => {
        const applicantDetails = this.props.myInfo ? this.props.applicantDetails : constants.applicantDetails;

        let stage6_file_error = ''
        if (!this.props.myInfo) {
            stage6_file_error = validations.validateRequiredFiles(this.state.stage6_files);
        }

        const stage6_employer_error = applicantDetails.employment.employer.source !== '1' ?
            validations.validateRequired(this.state.stage6_employer.trim()) : '';

        const stage6_occupation_error = applicantDetails.employment.occupation.source !== '1' ?
            validations.validateRequired(this.state.stage6_occupation.trim()) : '';

        const stage6_assessableIncome_error = applicantDetails.employment.assessibleIncome.source !== '1' ?
            validations.ValidateDecimalFormat(this.state.stage6_assessableIncome) : '';

        const stage6_yearOfNotice_error = applicantDetails.employment.assessmentYear.source !== '1' ?
            validations.ValidateYear(this.state.stage6_yearOfNotice) : '';

        this.setState(
            {
                stage6_employer_error,
                stage6_occupation_error,
                stage6_assessableIncome_error,
                stage6_yearOfNotice_error,
                stage6_file_error
            });

        if (
            stage6_employer_error || stage6_occupation_error
            || stage6_assessableIncome_error || stage6_yearOfNotice_error
            || stage6_file_error) {
            this.setState(
                {
                    stage6_employer_error,
                    stage6_occupation_error,
                    stage6_assessableIncome_error,
                    stage6_yearOfNotice_error,
                    stage6_file_error
                })
            return false;
        }

        return true;
    }

    onVerifyOccupation = () => {
        const isValid = this.validateOccupation();
        if (isValid) {

            // submit the application
            if (this.props.state.main.createCustomerFlow) {
                const applicantDetails = this.mapStateToApplicantDetails();
                this.props.onSubmitApplication(this.props.appForm, applicantDetails, this.state.stage4_files, this.state.stage6_files);
            } else {
                this.setState({
                    stageTitle: '4. Consents & Declarations'
                }, () => {
                    if(isEmpty(this.props.mainConsentContent))
                    {
                        this.props.onGetConsents(this.props.state.main.clientId, this.props.appForm.product, this.props.sessionId);
                    }
                    this.onChangeStage(7);
                })
            }


        }

    }

    onBackContact = () => {
        this.setState({
            stageTitle: '2. Contact Details'
        }, () => {
            this.onChangeStage(5);
        })
    }

    onVerifyConsent = () => {
        this.setState({
            stageTitle: 'Submit Application'
        }, () => {

            this.props.onGenerateOTP(this.props.sessionId, this.props.appForm.mobileNo ? this.props.appForm.mobileNo : this.state.stage5_mobile)

            this.onChangeStage(8);
        })
    }

    onResendOTP = () => {
        this.props.onGenerateOTP(this.props.sessionId, this.props.appForm.mobileNo ? this.props.appForm.mobileNo : this.state.stage5_mobile)
    }

    onBackOccupation = () => {
        this.setState({
            stageTitle: '3. Occupation Details'
        }, () => {
            this.onChangeStage(6);
        })
    }

    mapStateToApplicantDetails = () => {
        const {applicantDetails} = constants;

        if (this.props.myInfo) {
            applicantDetails.source = 'myInfo';
            applicantDetails.name.value = this.props.applicantDetails.name.value;
            applicantDetails.identityNo.value = this.props.applicantDetails.identityNo.value;
            applicantDetails.employment.cpfContributions = this.state.stage6_contribution;
            applicantDetails.drivingLicense = this.state.stage4_drivingLicenseObj;

            applicantDetails.name.source = this.props.applicantDetails.name.source;
            applicantDetails.identityNo.source = this.props.applicantDetails.identityNo.source;
            applicantDetails.dob.source = this.props.applicantDetails.dob.source;
            applicantDetails.gender.source = this.props.applicantDetails.gender.source;
            applicantDetails.race.source =this.props.applicantDetails.race.source;
            applicantDetails.maritalStatus.source = this.props.applicantDetails.maritalStatus.source;
            applicantDetails.nationality.source = this.props.applicantDetails.nationality.source;
            applicantDetails.residentialStatus.source = this.props.applicantDetails.residentialStatus.source;
            applicantDetails.employment.employer.source = this.props.applicantDetails.employment.employer.source;
            applicantDetails.employment.occupation.source = this.props.applicantDetails.employment.occupation.source;
            applicantDetails.employment.assessibleIncome.source = this.props.applicantDetails.employment.assessibleIncome.source;
            applicantDetails.employment.assessmentYear.source = this.props.applicantDetails.employment.assessmentYear.source;
            applicantDetails.residentialAddress.source = this.props.applicantDetails.residentialAddress.source;;
            applicantDetails.drivingLicense.source = this.props.applicantDetails.drivingLicense.source;
        } else {
            applicantDetails.source = 'manual';
            applicantDetails.name.value = this.state.stage4_name;
            applicantDetails.identityNo.value = this.state.stage4_nric;
            applicantDetails.employment.cpfContributions = [];
            applicantDetails.drivingLicense.source = '';
            if (this.state.stage4_drivingLicense.toUpperCase() === 'QUALIFIED') {
                applicantDetails.drivingLicense.qdl.status = this.state.stage4_drivingLicense;
                applicantDetails.drivingLicense.qdl.validity = this.state.stage4_licenseValidity;
                applicantDetails.drivingLicense.qdl.expirydate = this.state.stage4_licenseExpiryDate !== '' ? utilities.formatToDateTime(this.state.stage4_licenseExpiryDate) : null;
                applicantDetails.drivingLicense.qdl.classes = [
                    {
                        licenseClass: this.state.stage4_drivingLicenseClass,
                        issueDate: this.state.stage4_licenseIssueDate !== '' ? utilities.formatToDateTime(this.state.stage4_licenseIssueDate) : null
                    }
                ]
                applicantDetails.drivingLicense.pdl = null
            } else if (this.state.stage4_drivingLicense.toUpperCase() === 'PROVISIONAL') {
                applicantDetails.drivingLicense.pdl.status = this.state.stage4_drivingLicense;
                applicantDetails.drivingLicense.pdl.validity = this.state.stage4_licenseValidity_pdl;
                applicantDetails.drivingLicense.pdl.expirydate = this.state.stage4_licenseExpiryDate_pdl !== '' ? utilities.formatToDateTime(this.state.stage4_licenseExpiryDate_pdl) : null;
                applicantDetails.drivingLicense.pdl.classes = [
                    {
                        licenseClass: this.state.stage4_drivingLicenseClass_pdl,
                    }
                ]
                applicantDetails.drivingLicense.qdl = null;
            }
            applicantDetails.drivingLicense.supportingDocuments = this.props.licenseSupportedFiles.length > 0 ? this.props.licenseSupportedFiles : [];
            applicantDetails.employment.supportingDocuments = this.props.employementSupportedFiles.length > 0 ? this.props.employementSupportedFiles : [];;
        }

        if (this.state.stage4_drivingLicense.toUpperCase() === 'NOT APPLICABLE') {
            applicantDetails.drivingLicense.qdl = null;
            applicantDetails.drivingLicense.pdl = null;
        }
        applicantDetails.dob.value = this.state.stage4_dob !== '' ? utilities.formatToDateTime(this.state.stage4_dob) : null;;
        applicantDetails.gender.value = this.state.stage4_gender;
        applicantDetails.race.value = this.state.stage4_race;
        applicantDetails.maritalStatus.value = this.state.stage4_maritalStatus;
        applicantDetails.nationality.value = this.state.stage4_nationality;
        applicantDetails.residentialStatus.value = this.state.stage4_residentialStatus;

        applicantDetails.myInfoDate = null;

        applicantDetails.drivingLicense.status = this.state.stage4_drivingLicense;

        applicantDetails.contactDetails.mobileNo.value = this.state.stage5_mobile;
        applicantDetails.contactDetails.emailAddress.value = this.state.stage5_email;

        applicantDetails.residentialAddress.block = this.state.stage5_block;
        applicantDetails.residentialAddress.unit = this.state.stage5_unit;
        applicantDetails.residentialAddress.street = this.state.stage5_street;
        applicantDetails.residentialAddress.building = this.state.stage5_building;
        applicantDetails.residentialAddress.country = this.state.stage5_country;
        applicantDetails.residentialAddress.postalCode = this.state.stage5_postal;

        applicantDetails.employment.employer.value = this.state.stage6_employer;
        applicantDetails.employment.occupation.value = this.state.stage6_occupation;
        applicantDetails.employment.assessibleIncome.value = !this.state.stage6_assessableIncome ? 0 : parseFloat(String(this.state.stage6_assessableIncome).replace(/,/g, ''));
        applicantDetails.employment.assessmentYear.value = this.state.stage6_yearOfNotice;

        // no consents for customer flow
        if (!this.props.state.main.createCustomerFlow) {
            const otherFacilityAmount = this.props.appForm.product.toUpperCase() === 'HP' ? String(this.state.stage7_amount).replace(/,/g, '') : '';
            let contactChannel = ''
            if (this.state.stage7_marketAgree) {
                contactChannel = this.state.stage7_emailConsent ? 'Email, ' : '';
                contactChannel += (this.state.stage7_smsConsent ? 'Text message, ' : '');
                contactChannel += (this.state.stage7_callConsent ? 'Telephone Call,' : '');

                if (contactChannel !== '') {
                    contactChannel = contactChannel.replace(/,(?=[^,]*$)/, '');
                }
            }
            this.props.appForm.consent.isAgreeConsent = this.state.stage7_consent ? 'Y' : 'N';
            this.props.appForm.consent.otherContractFacility = otherFacilityAmount ? parseFloat(otherFacilityAmount) : null;
            this.props.appForm.consent.isAgreeMarketConsent = this.state.stage7_marketAgree ? 'Y' : 'N';
            this.props.appForm.consent.contactChannel = contactChannel;

            const applicationFormConsentViewModel = [
                {
                    applicationFormId: this.props.appForm.kycId,
                    consentId: this.props.mainConsentContent.checkboxAgree.consentId,
                    isAgree: this.state.stage7_consent,
                    consentDetails: {
                        key: 'OTHER_CONTRACT_FACILITY',
                        value: otherFacilityAmount
                    }
                },
                {
                    applicationFormId: this.props.appForm.kycId,
                    consentId: this.props.marketingConsentContent.checkboxAgree.consentId,
                    isAgree: this.state.stage7_marketAgree,
                    consentDetails: {
                        key: 'CONTACT_CHANNEL',
                        value: contactChannel
                    }
                },
            ]
            this.props.appForm.applicationFormConsentViewModel = applicationFormConsentViewModel;
        }

        return applicantDetails;
    }

    onVerifyOTP = () => {
        this.setState({
            stageTitle: 'Application Submitted'
        }, () => {
            const applicantDetails = this.mapStateToApplicantDetails();
            const otp = this.state.otp1 + this.state.otp2 + this.state.otp3 + this.state.otp4 + this.state.otp5 + this.state.otp6;
            this.state.stage4_files_nric = this.state.stage4_files_nric.concat(this.state.stage4_files);
            this.state.stage6_files = this.state.stage6_files.concat(this.state.stage6_files_others);
            this.props.onValidateOTP(this.props.sessionId, otp, this.props.appForm, applicantDetails, this.state.stage4_files_nric, this.state.stage6_files)
        })

    }

    handleChangeByName = (name, val) => {
        if (
            name === 'stage7_amount'
        ) {
            const test = validations.validateCurrencyInput(val);
            val = test !== '' ? val.substring(0, val.length - 1) : val;
        }

        this.setState({
            [name]: val
        });
    }

    handleLicenseChange = (e, name, isQDL, classIndex) => {
        const val = e.value;
        if (isQDL) {
            const qdlClasses = [...this.state.stage4_drivingLicenseObj.qdl.classes];
            if (name === 'licenseClass') {
                qdlClasses[classIndex].licenseClass = val;
            } else if (name === 'issueDate') {
                qdlClasses[classIndex].issueDate = val;
            }
            if (classIndex !== -1) {
                this.setState((state) => ({
                    stage4_drivingLicenseObj: {
                        ...state.stage4_drivingLicenseObj,
                        qdl: {
                            ...state.stage4_drivingLicenseObj.qdl,
                            classes: [...qdlClasses],
                        }

                    },
                }));
            } else if (classIndex === -1) {
                this.setState((state) => ({
                    stage4_drivingLicenseObj: {
                        ...state.stage4_drivingLicenseObj,
                        qdl: {
                            ...state.stage4_drivingLicenseObj.qdl,
                            [name]: val,
                        }

                    },
                }));
            }

        } else {
            const pdlClasses = this.state.stage4_drivingLicenseObj.pdl.classes;
            if (name === 'licenseClass') {
                pdlClasses[classIndex].licenseClass = val;
            }
            if (classIndex !== -1) {
                this.setState((state) => ({
                    stage4_drivingLicenseObj: {
                        ...state.stage4_drivingLicenseObj,
                        pdl: {
                            ...state.stage4_drivingLicenseObj.pdl,
                            classes: [...pdlClasses],
                        }

                    },
                }));
            } else if (classIndex === -1) {
                this.setState((state) => ({
                    stage4_drivingLicenseObj: {
                        ...state.stage4_drivingLicenseObj,
                        pdl: {
                            ...state.stage4_drivingLicenseObj.pdl,
                            [name]: val,
                        }

                    },
                }));
            }
        }
    }

    handleKeyPress = (e) => {

        const { keyCode: charCode, target: { name } } = e;

        const isNumericCode = charCode > 47 && charCode < 58;
        const isUpperLetters = charCode > 64 && charCode < 91;
        const isLowerLetters = charCode > 96 && charCode < 123;

        if (name === 'stage4_name') {
            if (e.shiftKey && isNumericCode) {
                e.preventDefault();
            }

            if (!((isUpperLetters) || (charCode > 36 && charCode < 41) || (isLowerLetters) || charCode === 8 || charCode === 32 || charCode === 9)) {
                e.preventDefault();
            }
        }

        if (name === 'stage4_nric') {
            if (e.shiftKey && isNumericCode) {
                e.preventDefault();
            }
            if (!((charCode > 36 && charCode < 41) ||
                isNumericCode ||
                (isUpperLetters) ||
                (isLowerLetters) ||
                charCode === 8 || charCode === 46 || charCode === 9
            )) {
                e.preventDefault();
            }
        }

        if (name === 'stage5_mobile') {
            if (e.shiftKey && isNumericCode) {
                e.preventDefault();
            }
            if (!((isNumericCode) || (charCode > 36 && charCode < 41) || charCode === 8 || charCode === 46 || charCode === 9)) {
                e.preventDefault();
            }
        }

        if (name === 'stage5_postal') {
            if (e.shiftKey && (isNumericCode)) {
                e.preventDefault();
            }
            if (!((isNumericCode) || (charCode > 36 && charCode < 41) || charCode === 8 || charCode === 46 || charCode === 9)) {
                e.preventDefault();
            }
        }

        if (name === 'stage5_email') {
            if (e.shiftKey && (charCode === 48 || charCode === 49 || charCode === 190 || (charCode > 50 && charCode < 58))) {
                e.preventDefault();
            }
            if (!(charCode === 32) && // space
                !(isNumericCode) && // numeric (0-9)
                !(isUpperLetters) && // upper alpha (A-Z)
                !(isLowerLetters) && // lower alpha (a-z)
                !(charCode === 8) && // backspace
                !(charCode === 190) && // decimal
                !(charCode === 189) && // hiphen
                !(charCode === 46) &&
                !(charCode === 9)
            ) {
                e.preventDefault();
            }
        }
    }

    handleReactSelectChange = (newValue, { name }) => {
        if ((newValue.value !== '')) {
            const {value} = newValue;

            const state = {
                [name]: value,
                [`${name  }_error`]: ''
            };

            // set date picker to false if license status changed
            if (name === 'stage4_drivingLicense') {
                state.isDatePickerInitialized = false;
            }

            this.setState(
                state,
                () => {
                    if (name === 'stage4_drivingLicense') {
                        if (value.toUpperCase() === 'QUALIFIED') {
                            this.onInitTDP('.tdp_issueDate', 'stage4_licenseIssueDate', new Date());
                            this.onInitTDP('.tdp_expiryDate', 'stage4_licenseExpiryDate', '')
                        }
                        if (value.toUpperCase() === 'PROVISIONAL') {
                            this.onInitTDP('.tdp_expiryDate', 'stage4_licenseExpiryDate_pdl', '')
                        }
                    }
                });
        }
    };

    handleChange = (e) => {
        const {name} = e.target;
            let val = e.target.value;
        if (
            name === 'nric1' ||
            name === 'nric2' ||
            name === 'nric3' ||
            name === 'nric4'
        ) {
            val = val.toUpperCase();
            const test = /^[a-z0-9]+$/i.test(val);
            if (test === false || val.length > 1) {
                val = val.substring(0, val.length - 1);
            }
            this.setState({ showError: false });
        }

        if (
            name === 'otp1' ||
            name === 'otp2' ||
            name === 'otp3' ||
            name === 'otp4' ||
            name === 'otp5' ||
            name === 'otp6'
        ) {
            const test = /^\d+$/.test(val);
            if (test === false || val.length > 1) {
                val = val.substring(0, val.length - 1);
            }
        }
        this.setState({
            [name]: val
        }, () => {
            
            if (name === 'stage4_name') {
                if ((val.length >= 1)) {
                    this.setState({ stage4_name_error: '' })
                }
            }

            if (name === 'stage4_nric') {
                if ((val.length >= 1)) {
                    this.setState({ stage4_nric_error: '' })
                }
            }
            if (name === 'stage4_dob') {
                if ((val.length >= 1)) {
                    this.setState({ stage4_dob_error: '' })
                }
            }

            if (name === 'stage4_gender') {
                if ((val !== '')) {
                    this.setState({ stage4_gender_error: '' })
                }
            }

            if (name === 'stage4_race') {
                if ((val !== '')) {
                    this.setState({ stage4_race_error: '' })
                }
            }
            if (name === 'stage4_dob') {
                if (val !== '') {
                    this.setState({ stage4_dob_error: '' })
                }
            }
            if (name === 'stage4_maritalStatus') {
                if ((val !== '')) {
                    this.setState({ stage4_maritalStatus_error: '' })
                }
            }

            if (name === 'stage4_nationality') {
                if ((val !== '')) {
                    this.setState({ stage4_nationality_error: '' })
                }
            }

            if (name === 'stage4_residentialStatus') {
                if ((val !== '')) {
                    this.setState({ stage4_residentialStatus_error: '' })
                }
            }

            if (name === 'stage4_drivingLicense') {
                if ((val !== '')) {
                    this.setState({
                        stage4_drivingLicense_error: '',
                        isDatePickerInitialized: false
                    })
                }
            }

            if (name === 'stage4_drivingLicenseClass') {
                if ((val !== '')) {
                    this.setState({ stage4_drivingLicenseClass_error: '' })
                }
            }

            if (name === 'stage4_licenseIssueDate') {
                if ((val.length >= 1)) {
                    this.setState({ stage4_licenseIssueDate_error: '' })
                }
            }

            if (name === 'stage4_licenseValidity') {
                if ((val !== '')) {
                    this.setState({ stage4_licenseValidity_error: '' })
                }
            }

            if (name === 'stage4_licenseExpiryDate') {
                if ((val.length >= 1)) {
                    this.setState({ stage4_licenseExpiryDate_error: '' })
                }
            }

            if (name === 'stage4_drivingLicenseClass_pdl') {
                if ((val !== '')) {
                    this.setState({ stage4_drivingLicenseClass_pdl_error: '' })
                }
            }

            if (name === 'stage4_licenseValidity_pdl') {
                if ((val !== '')) {
                    this.setState({ stage4_licenseValidity_pdl_error: '' })
                }
            }

            if (name === 'stage4_licenseExpiryDate_pdl') {
                if ((val.length >= 1)) {
                    this.setState({ stage4_licenseExpiryDate_pdl_error: '' })
                }
            }


            if (name === 'stage5_mobile') {
                if ((val.length >= 1)) {
                    this.setState({ stage5_mobile_error: '' })
                }
            }

            if (name === 'stage5_email') {
                if ((val.length >= 1)) {
                    this.setState({ stage5_email_error: '' })
                }
            }

            if (name === 'stage5_block') {
                if ((val.length >= 1)) {
                    this.setState({ stage5_block_error: '' })
                }
            }

            if (name === 'stage5_unit') {
                if ((val.length >= 1)) {
                    this.setState({ stage5_unit_error: '' })
                }
            }

            if (name === 'stage5_street') {
                if ((val.length >= 1)) {
                    this.setState({ stage5_street_error: '' })
                }
            }

            if (name === 'stage5_building') {
                if ((val.length >= 1)) {
                    this.setState({ stage5_building_error: '' })
                }
            }

            if (name === 'stage5_country') {
                if ((val !== '')) {
                    this.setState({ stage5_country_error: '' })
                }
            }

            if (name === 'stage5_postal') {
                if ((val.length >= 1)) {
                    this.setState({ stage5_postal_error: '' })
                }
            }

            if (name === 'stage6_employer') {
                if ((val.length >= 1)) {
                    this.setState({ stage6_employer_error: '' })
                }
            }

            if (name === 'stage6_occupation') {
                if ((val.length >= 1)) {
                    this.setState({ stage6_occupation_error: '' })
                }
            }

            if (name === 'stage6_assessableIncome') {
                if ((val.length >= 1)) {
                    this.setState({ stage6_assessableIncome_error: '' })
                }
            }

            if (name === 'stage6_yearOfNotice') {
                if ((val !== 'default')) {
                    this.setState({ stage6_yearOfNotice_error: '' })
                }
            }

            if (name === 'stage7_amount') {
                if ((val.length >= 1)) {
                    this.setState({ stage7_amount_error: '' })
                }
            }

            if (name === 'stage4_drivingLicense') {
                if (val.toUpperCase() === 'QUALIFIED') {
                    this.onInitTDP('.tdp_issueDate', 'stage4_licenseIssueDate', new Date());
                    this.onInitTDP('.tdp_expiryDate', 'stage4_licenseExpiryDate', '')
                }
                if (val.toUpperCase() === 'PROVISIONAL') {
                    this.onInitTDP('.tdp_expiryDate', 'stage4_licenseExpiryDate_pdl', '')
                }
            }
        })
    }

    handleCheckbox = (e) => {
        const {name} = e.target;
        this.setState({
            [name]: e.target.checked
        }, () => {
            if (name === 'stage7_consent') {
                this.setState({ stage7_consent_error: '' })
            }
        })
    }


    

    getTitle = (stage) => {
        if (stage === 1 || this.props.state.main.stage === 10) {
            return 'Finance Application';
        } if (this.props.state.main.stage === 2 || this.props.state.main.stage === 3) {
            return 'Your Application';
        } if (this.props.state.main.stage === 9) {
            return 'Application Submitted';
        } if (this.props.state.main.stage === 4) {
            return '1. Applicant Details';
        } if (this.props.state.main.stage === 5) {
            return '2. Contact Details';
        } if (this.props.state.main.stage === 6) {
            return '3. Occupation Details';
        } if (this.props.state.main.stage === 7) {
            return '4. Consents & Declarations';
        } if (this.props.state.main.stage === 8) {
            return 'Submit Application';
        } if (this.props.state.main.stage === 9) {
            return 'Application Submitted';
        } if (this.props.state.main.stage === 12) {
            return 'Application Not Completed';
        }

    }

    

    render() {
        const {state} = this;
        const rdxState = this.props.state;

        const title = this.getTitle(this.props.state.main.stage);

        const isNRICButtonDisabled = state.nric4 === '' || state.nric3 === '' || state.nric2 === '' || state.nric1 === '';
        const isStage2NextButtonDisabled = this.props.errorGetApplication !== '';
        const {
            kycId = '',
            price = '',
            make = '',
            makeName = '',
            modelName = '',
            variantName = '',
            loanAmount = '',
            tenure = '',
            // interestRate = '',
            leaseRental = ''        } = this.props.appForm;
        const myInfoMode = this.props.myInfo;
        const applicantDetails = myInfoMode ? this.props.applicantDetails : constants.applicantDetails;

        const drivLicense = state.stage4_drivingLicenseObj
        if (drivLicense.qdl != null) {
            if (drivLicense.qdl.classes.length > 0) {
                drivLicense.qdl.classes.forEach(element => {
                    element.issueDate = !element.issueDate ? '' : element.issueDate;
                });
            }
            drivLicense.qdl.expirydate = !drivLicense.qdl.expirydate ? '' : drivLicense.qdl.expirydate;
        }

        let enableConsentButton = false;
        let showConsentValidationMsg = false;
        const showAmountError = state.stage7_amount === '';
        if (state.stage7_consent) {
            enableConsentButton = true
            if (state.stage7_marketAgree && !state.stage7_callConsent
                && !state.stage7_smsConsent && !state.stage7_emailConsent) {
                enableConsentButton = false
            }
            if (!state.stage7_marketAgree && !state.stage7_marketNotAgree) {
                enableConsentButton = false
            }
            if (showAmountError) {
                enableConsentButton = false
            }
        }
        if (state.stage7_marketAgree && !state.stage7_callConsent
            && !state.stage7_smsConsent && !state.stage7_emailConsent
        ) {
            showConsentValidationMsg = true
        }
        showConsentValidationMsg = state.stage7_marketAgree && !state.stage7_callConsent && !state.stage7_smsConsent && !state.stage7_emailConsent;

        if (drivLicense.pdl != null) {
            drivLicense.pdl.expirydate = !drivLicense.pdl.expirydate ? '' : drivLicense.pdl.expirydate;
        }
        let clientDefaultPhoneNo = '';// this.props.defaultPhoneNo != null ? this.props.defaultPhoneNo.filter(function (phoneNo) { return phoneNo.ClientId === this.props.appForm.make }) : constants.DEFAULTPHONENO;
        if (this.props.defaultPhoneNo != null && this.props.defaultPhoneNo !== undefined) {
            const filteredValue = this.props.defaultPhoneNo.filter(function (phoneNo) { return phoneNo.clientId.toUpperCase() === state.stage2_make.toUpperCase() })[0];
            if (filteredValue !== undefined) {
                clientDefaultPhoneNo = filteredValue.value;
            }
        }
        const interestRate = `${this.props.appForm.interestRate  } %`;
        const licenseStatus = state.stage4_drivingLicenseObj.status;

        const arrMakeModel = [makeName, modelName, variantName];
        const makeModel = arrMakeModel.filter(Boolean).join(' ');
        return (
            <>
                {(rdxState.main.stage > 1 && rdxState.main.stage < 9) ?
                    <SessionIdleTimer /> : ''}

                <TitleWrap>
                    {title}
                </TitleWrap>
                <BodyWrap>
                    {
                        rdxState.main.stage === 1 ?
                                <NRICLogin
                                    financialService={this.props.financialService}
                                    state ={this.state}
                                    handleChange = {this.handleChange}
                                    isNRICButtonDisabled = {isNRICButtonDisabled}
                                    onCheckNRIC ={() => this.onCheckNRIC()}
                                    errorNricValid ={this.props.errorNricValid}
                                />: ''
                    }
                    {
                        rdxState.main.stage === 2 ?
                            <ApplicationDetails
                                kycId = {kycId}
                                price = {price}
                                makeModel = {makeModel}
                                loanAmount = {loanAmount}
                                tenure = {tenure}
                                leaseRental = {leaseRental}
                                interestRate = {interestRate}
                                isLease = {this.props.appForm.isLease}
                                isStage2NextButtonDisabled ={isStage2NextButtonDisabled}
                                errorGetApplication ={this.props.errorGetApplication}
                                validateApplicationForm = {this.validateApplicationForm}
                            /> : ''
                    }
                    {
                        rdxState.main.stage === 3 ?
                            <ApplicationChoice
                                brand={this.props.brand}
                                onApply = {this.onApply}
                                handleCheckbox = {this.handleCheckbox}
                                myInfoSettings = {this.props.myInfoSettings}
                                stage3_consent = { state.stage3_consent }
                                corpCustomer = {rdxState.main.corpCustomer}
                            /> : ''
                    }
                    {
                        rdxState.main.stage === 4 ?
                            <ApplicantDetails
                                state ={state}
                                applicantDetails = {applicantDetails}
                                drivLicense = {drivLicense}
                                licenseStatus ={licenseStatus}
                                myInfoMode ={myInfoMode}
                                properties = {this.props}
                                onChange = {this.handleChange}
                                onKeyDown={this.handleKeyPress}
                                onReactSelectChange={this.handleReactSelectChange}
                                onHandleLicenseChange={this.handleLicenseChange}
                                onFileRemove = {this.onFileRemove}
                                onFileUpload = {this.onFileUpload}
                                onVerifyApplicant ={this.onVerifyApplicant}
                            /> : ''
                    }
                    {
                        rdxState.main.stage === 5 ?
                            <ContactDetails 
                                state ={state}
                                applicantDetails = {applicantDetails}
                                country = {this.props.country}
                                onChange = {this.handleChange}
                                onKeyDown={this.handleKeyPress}
                                onReactSelectChange={this.handleReactSelectChange}
                                onBackApplicant = {this.onBackApplicant}
                                onVerifyContact = {this.onVerifyContact}
                            />:''
                    }
                    {
                        rdxState.main.stage === 6 ?
                            <OccupationDetails
                                myInfoMode = {myInfoMode}
                                state ={state}
                                applicantDetails = {applicantDetails}
                                errorSubmitApplication ={this.props.errorSubmitApplication}
                                onChange = {this.handleChange}
                                onKeyDown={this.handleKeyPress}
                                onBackContact ={this.onBackContact}
                                onVerifyOccupation = {this.onVerifyOccupation}
                                onFileRemove = {this.onFileRemove}
                                onFileUpload = {this.onFileUpload}
                            />: ''
                    }
                    {
                        rdxState.main.stage === 7 && !isEmpty(this.props.mainConsentContent) ?
                            <div>
                                {this.props.appForm.product.toUpperCase() === 'HP' ?
                                    <HP
                                        stage7_consent={state.stage7_consent}
                                        stage7_amount={state.stage7_amount}
                                        stage7_emailConsent={state.stage7_emailConsent}
                                        stage7_smsConsent={state.stage7_smsConsent}
                                        stage7_callConsent={state.stage7_callConsent}
                                        stage7_marketAgree={state.stage7_marketAgree}
                                        stage7_marketNotAgree={state.stage7_marketNotAgree}
                                        showConsentValidationMsg={showConsentValidationMsg}
                                        showAmountError={showAmountError}
                                        data={this.props}
                                        onChangeState={this.handleChangeByName}
                                    />
                                    :
                                    <OL
                                        stage7_consent={state.stage7_consent}
                                        stage7_emailConsent={state.stage7_emailConsent}
                                        stage7_smsConsent={state.stage7_smsConsent}
                                        stage7_callConsent={state.stage7_callConsent}
                                        stage7_marketAgree={state.stage7_marketAgree}
                                        stage7_marketNotAgree={state.stage7_marketNotAgree}
                                        showConsentValidationMsg={showConsentValidationMsg}
                                        data={this.props}
                                        onChangeState={this.handleChangeByName}
                                    />
                                }
                                <ButtonWrap>
                                    <BackButton onClick={() => this.onBackOccupation()}>
                                        Back
                                    </BackButton>
                                    <Button disabled={!enableConsentButton} onClick={() => enableConsentButton ? this.onVerifyConsent() : null}>
                                        Next
                                    </Button>
                                </ButtonWrap>
                            </div> : ''
                    }
                    {
                        rdxState.main.stage === 8 ?
                            <OTP
                                state={state}
                                otpSettings = {this.props.otpSettings}
                                errorValidateOTP ={this.props.errorValidateOTP}
                                errorGenerateOTP = {this.props.errorGenerateOTP}
                                otpText ={this.props.otpText}
                                otpGeneratedTime = {this.props.otpGeneratedTime}
                                onResendOTP = {this.onResendOTP}
                                onVerifyOTP = {this.onVerifyOTP}
                                onChange = {this.handleChange}
                            />: ''
                    }
                    {
                        rdxState.main.stage === 9 ?
                            <ApplicationMessages 
                                dataTestId = 'thankYou'                        
                                title = 'Thank you!'
                                content = 'Your vehicle finance application has been submitted successfully. We will notify you of the outcome soon.'
                            /> : ''
                    }
                    {
                        rdxState.main.stage === 10 ?
                            <ApplicationMessages 
                                dataTestId = 'invalidLink' 
                                title = 'Invalid link!'
                                content = {`This application link has expired. Please call ${  clientDefaultPhoneNo  } for assistance.`}
                            />  : ''
                    }
                    {
                        rdxState.main.stage === 11 ?
                            <ApplicationMessages 
                                dataTestId = 'errorPage' 
                                title = 'Error'
                                content = {`An error occurred. Please try again later, and call ${  clientDefaultPhoneNo  } for assistance if the issue persists.`}
                            /> : ''
                    }
                    {
                        rdxState.main.stage === 12 ?
                            <ApplicationMessages 
                                dataTestId = 'sessionExpired' 
                                title = 'Session Expired'
                                content = 'The application session has timed out. Please Re-submit.'
                            /> : ''
                    }
                </BodyWrap>
            </>
        );
    }
}


const mapStateToProps = state => {
    const {
        errorDropDownValidation,
        dataValues,
        gender,
        race,
        maritalStatus,
        nationality,
        residentialStatus,
        defaultPhoneNo,
        country,
        licenceValidity,
        validation,
        myInfoRequestParamters,
        drivingLicenseManualClasses,
        residentialStatusManual,
        genderManual,
        drivingLicenseValidityManual,
        drivingLicenseClass,
        drivingLicenseStatus,
        otpSettings,
        myInfoSettings
    } = state.getDropDownReducer

    const {
        errorNricValid
    } = state.checkNRICSessionReducer

    const {
        errorValidateSession,
        financialService
    } = state.loadClientStyleReducer

    const {
        appForm,
        applicantDetails,
        errorGetApplication
    } = state.getApplicationReducer

    const {
        errorGenerateOTP,
        otpText,
        otpGeneratedTime
    } = state.generateOTPReducer

    const {
        errorFileUpload,
        licenseSupportedFiles,
        employementSupportedFiles
    } = state.uploadFileReducer

    const {
        errorSubmitApplication
    } = state.submitApplicationReducer

    const {
        myInfo
    } = state.main

    const {
        errorValidateOTP
    } = state.validateOTPReducer


    const {
        errorMyInfoFailed
    } = state.getMyInfoDataReducer

    const {
        consents,
        mainConsentContent,
        marketingConsentContent
    } = state.getConsentsReducer

    return {
        state,
        errorNricValid,
        errorValidateSession,
        financialService,
        appForm,
        applicantDetails,
        errorGetApplication,
        errorDropDownValidation,
        dataValues,
        gender,
        race,
        otpText,
        maritalStatus,
        nationality,
        residentialStatus,
        country,
        licenceValidity,
        validation,
        defaultPhoneNo,
        errorGenerateOTP,
        errorFileUpload,
        licenseSupportedFiles,
        employementSupportedFiles,
        errorSubmitApplication,
        myInfo,
        errorValidateOTP,
        errorMyInfoFailed,
        myInfoRequestParamters,
        consents,
        mainConsentContent,
        marketingConsentContent,
        drivingLicenseManualClasses,
        residentialStatusManual,
        genderManual,
        drivingLicenseValidityManual,
        drivingLicenseClass,
        drivingLicenseStatus,
        otpSettings,
        otpGeneratedTime,
        myInfoSettings
    }

}

const mapDispatchToProps = dispatch => {

    return {
        onChangeStage: (stage) => dispatch(actions.stageUpdate(stage)),
        onCheckNRICSession: (nricNo, sessionId) => dispatch(actions.checkNricSessionStart(nricNo, sessionId)),
        onGenerateOTP: (sessionId, mobileNo) => dispatch(actions.onGenerateOTPStart(sessionId, mobileNo)),
        onSubmitApplication: (applicationDetails, applicantDetails, licenseFiles, employmentFiles) => dispatch(actions.submitApplicationStart(applicationDetails, applicantDetails, licenseFiles, employmentFiles)),
        onUploadFile: (file, source, docType) => dispatch(actions.uploadFileStart(file, source, docType)),
        onGetApplicationDetails: (sessionId) => dispatch(actions.getApplicationDetailsStart(sessionId)),
        onValidateOTP: (sessionId, otp, appForm, applicantDetails, licenseFiles, employmentFiles) => dispatch(actions.onValidateOTPStart(sessionId, otp, appForm, applicantDetails, licenseFiles, employmentFiles)),
        onUpdateSource: (flag) => dispatch(actions.updateSource(flag)),
        onGetMyInfoData: (sessionId, includeCpf) => dispatch(actions.onAuthorizeMyInfoDataStart(sessionId, includeCpf)),
        onGetConsents: (clientId, productId, sessionId) => dispatch(actions.onGetConsentsStart(clientId, productId, sessionId)),
    }
}

KYC.propTypes = {
    appForm: PropTypes.object
}

export default connect(mapStateToProps, mapDispatchToProps)(KYC);
